import { GroupOptionsEnums } from '@/models/group-options-enums';

export abstract class GroupOption {
	public abstract get displayText(): string;

	public abstract equals(option: GroupOption): boolean;
	public abstract getHashKey(): GroupOptionsEnums;
}
